(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const nav = header.querySelector('[data-header-mega-nav]');
    const panelsContainer = header.querySelector('[data-header-mega-panels]');
    if (!nav || !panelsContainer) return;

    // Optional override for local testing
    const debugHandle = '';

    const triggers = Array.from(nav.querySelectorAll('[data-mega-trigger]'));
    if (!triggers.length) return;

    const triggerLinks = new Map();
    triggers.forEach(trigger => {
      const handle = trigger.dataset.megaTrigger;
      const link = trigger.querySelector('a');

      if (handle && link) {
        triggerLinks.set(handle, link);
      }
    });

    // Map handles to panel elements.
    const panels = new Map();
    panelsContainer.querySelectorAll('[data-header-mega]').forEach(panel => {
      const handle = panel.dataset.headerMega;
      if (handle) panels.set(handle, panel);
    });

    if (!panels.size) return;

    const mq = window.matchMedia('(min-width: 1280px)');
    const hideClasses = ['hidden', 'pointer-events-none', 'opacity-0', 'invisible', '-translate-y-2'];
    const showClasses = ['pointer-events-auto', 'opacity-100', 'visible', 'translate-y-0'];
    const HOVER_OPEN_DELAY = 150;

    let activeHandle = null;
    let hideTimer = null;
    let openTimer = null;

    // Toggle panel visibility without dropping existing classes
    function applyPanelState(panel, isActive) {
      hideClasses.forEach(cls => panel.classList[isActive ? 'remove' : 'add'](cls));
      showClasses.forEach(cls => panel.classList[isActive ? 'add' : 'remove'](cls));
      panel.setAttribute('aria-hidden', String(!isActive));
    }

    function setTriggerState(handle, isActive) {
      const link = triggerLinks.get(handle);

      if (link) {
        link.setAttribute('aria-expanded', String(isActive));
        link.classList.toggle('header-mega-link-active', isActive);
      }
    }

    // Hide panel
    function deactivate() {
      if (activeHandle === null) return;

      const activePanel = panels.get(activeHandle);
      if (activePanel) {
        applyPanelState(activePanel, false);
      }

      setTriggerState(activeHandle, false);
      panelsContainer.classList.add('hidden');

      activeHandle = null;
    }

    // Show panel
    function activate(handle, options = { force: false }) {
      if (!mq.matches && !options.force) return;
      if (!panels.has(handle)) return;
      if (activeHandle === handle) return;

      if (activeHandle) {
        const previousPanel = panels.get(activeHandle);

        if (previousPanel) {
          applyPanelState(previousPanel, false);
        }

        setTriggerState(activeHandle, false);
      }

      activeHandle = handle;
      const panel = panels.get(handle);

      applyPanelState(panel, true);
      setTriggerState(handle, true);
      panelsContainer.classList.remove('hidden');
    }

    function scheduleDeactivate() {
      clearTimeout(openTimer);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        if (mq.matches) {
          deactivate();
        }
      }, 120);
    }

    function cancelDeactivate() {
      clearTimeout(hideTimer);
    }

    function scheduleActivate(handle) {
      clearTimeout(openTimer);
      openTimer = setTimeout(() => {
        activate(handle);
      }, HOVER_OPEN_DELAY);
    }

    function cancelActivate() {
      clearTimeout(openTimer);
    }

    // Nav events
    triggers.forEach(trigger => {
      const handle = trigger.dataset.megaTrigger;
      if (!handle) return;

      trigger.addEventListener('pointerenter', () => {
        cancelDeactivate();
        scheduleActivate(handle);
      });

      trigger.addEventListener('focusin', () => {
        cancelDeactivate();
        cancelActivate();
        activate(handle);
      });

      trigger.addEventListener('pointerleave', () => {
        cancelActivate();
        scheduleDeactivate();
      });

      trigger.addEventListener('focusout', () => {
        hideTimer = setTimeout(() => {
          if (!header.contains(document.activeElement)) {
            deactivate();
          }
        }, 120);
      });
    });

    // Panel events
    panels.forEach(panel => {
      panel.addEventListener('pointerenter', cancelActivate);
      panel.addEventListener('pointerenter', cancelDeactivate);
      panel.addEventListener('pointerleave', scheduleDeactivate);
      panel.addEventListener('focusin', cancelDeactivate);
      panel.addEventListener('focusout', () => {
        hideTimer = setTimeout(() => {
          if (!header.contains(document.activeElement)) {
            deactivate();
          }
        }, 120);
      });
    });

    // Close menu on escape
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        deactivate();
        const link = activeHandle ? triggerLinks.get(activeHandle) : null;
        if (link) {
          link.focus();
        }
      }
    });

    // Close menu on click outside
    document.addEventListener('pointerdown', event => {
      if (!header.contains(event.target)) {
        cancelActivate();
        deactivate();
      }
    });

    mq.addEventListener('change', () => {
      if (!mq.matches) {
        cancelActivate();
        deactivate();
      }
    });

    if (debugHandle && panels.has(debugHandle)) {
      activate(debugHandle, { force: true });
      cancelDeactivate();
    }
  });
})();
